var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-button-logout"},[(_vm.authenticated)?_c('button',{staticClass:"button",on:{"click":_vm.handleClick}},[_vm._v(" Logout ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }